import React, { useEffect, useRef, useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
const RefreshMap = (props) => {
  const { map, markerRef } = props;
  const handleRefreshMap = () => {
    map?.current?.flyTo({
      center: [69.3451, 30.3753],
      zoom: 5,
      bearing: 0,
    });

    if (markerRef?.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
  };
  return (
    <div
      style={{
        position: 'absolute',
        bottom: '12%',
        right: '11px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 1,
        marginBottom: '30px',
        cursor: 'pointer',
      }}
      onClick={handleRefreshMap}
    >
      <div
        style={{
          width: '27px',
          height: '40px',
          background: 'white',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease-in-out',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f0f0f0';
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'white';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <RefreshIcon />
      </div>
    </div>
  );
};

export default RefreshMap;
